// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".special-banner[data-v-6cac8672]{background:#ee8a2e;-webkit-clip-path:polygon(20% 5%,80% 5%,100% 90%,0 90%);clip-path:polygon(20% 5%,80% 5%,100% 90%,0 90%);padding:.5rem 2rem;right:-2.35rem;top:1.25rem;transform:rotate(45deg);transform-origin:center}div[data-v-6cac8672] .field-label--large{margin-bottom:2rem}div[data-v-6cac8672] .select-input__selected{max-height:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
